import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormFieldComponent } from './form-field.component';

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        FormFieldComponent,
    ],
    exports: [
        FormFieldComponent,
    ]
})
export class FormFieldModule {
}
